
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getNotificationClientHeaders } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetNotificationClientApi = createAsyncThunk(
  "hitGetNotificationClientApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("clientToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getNotificationClientHeaders;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetNotificationClientSlice = createSlice({
  name: "getNotificationClientReducer",
  initialState: {
    isLoading: false,
    data: null,
    status: null,
    isError: false,
  },
  reducers: {
    clearhitGetNotificationClientData: (state) => {
      state.data = null;
      state.status = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetNotificationClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetNotificationClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
        state.data = action.payload;
      })
      .addCase(hitGetNotificationClientApi.rejected, (state) => {
        state.status = false;
        state.isError = false;
      });
  },
});

export const { clearhitGetNotificationClientData } = GetNotificationClientSlice.actions;
export default GetNotificationClientSlice.reducer;